import {
  calcularDataLimite,
  equipePrazoVencidoMessage,
  formatDataBr,
  isPrazoVencido,
} from "@/modules/recursos/equipe-obra.rules";

import { PAPEIS_OBRIGATORIOS_ADD_LABEL } from "./papeis-obrigatorios.constants";
import type {
  PapeisObrigatoriosProps,
  PapeisObrigatoriosViewModel,
} from "./types-papeis-obrigatorios";

/** Prazo, vencimento e rótulos de cada papel já calculados; sem JSX. */
export function usePapeisObrigatorios({
  papeis,
  adicionados,
  periodo,
  hoje,
  carregando,
  aberto,
  onAlternar,
  onAdicionar,
  somenteLeitura = false,
  textoCarregando,
}: PapeisObrigatoriosProps): PapeisObrigatoriosViewModel {
  const itens = papeis.map((papel) => {
    const limite = periodo ? calcularDataLimite(papel.janela, periodo.inicio, periodo.fim) : null;
    const adicionado = adicionados.has(papel.id);
    const vencido = limite ? isPrazoVencido(limite.data, hoje) : false;

    return {
      id: papel.id,
      nome: papel.nome,
      prazo: limite ? `Até ${formatDataBr(limite.data)} · (${limite.rotulo})` : null,
      adicionado,
      mensagemVencido: !adicionado && vencido ? equipePrazoVencidoMessage(papel.nome) : null,
      mostrarAdicionar: !adicionado && !somenteLeitura,
      adicionarLabel: `${PAPEIS_OBRIGATORIOS_ADD_LABEL} ${papel.nome}`,
      testId: `equipe-obra-required-${papel.id}`,
      adicionadoTestId: `equipe-obra-added-${papel.id}`,
      adicionarTestId: `equipe-obra-add-${papel.id}`,
      adicionar: () => onAdicionar(papel),
    };
  });

  return {
    aberto,
    alternar: () => onAlternar(),
    itens,
    adicionarDesabilitado: !periodo,
    mostrarVazio: !carregando && papeis.length === 0,
    textoCarregando: carregando ? textoCarregando : undefined,
  };
}
